export const PODImageMap = [
  { url: 'https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/print_customize/T-shirt.png',
    value: 1,
    text: 'T-shirt'
  },
  { url: 'https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/print_customize/Hoodie.png',
    value: 2,
    text: 'Hoodie'
  },
  { url: 'https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/print_customize/Long%20Sleeve%20T-Shirt.png',
    value: 3,
    text: 'Long Sleeve T-Shirt'
  },
  { url: 'https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/print_customize/Slim%20Fit%20T-shirt.png',
    value: 4,
    text: 'Slim Fit T-shirt'
  },
  { url: 'https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/print_customize/Shirt.png',
    value: 5,
    text: 'Shirt'
  },
  { url: 'https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/print_customize/Polo%20Shirts.png',
    value: 6,
    text: 'Polo Shirts'
  },
  { url: 'https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/print_customize/Pants.png',
    value: 7,
    text: 'Pants'
  },
  { url: 'https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/print_customize/Shorts.png',
    value: 8,
    text: 'Shorts'
  }]

export const customizeOnDemandImage = 'https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/customizeOnDemand.png'
